module.exports = __webpack_public_path__ + "img/overview_banner.0e53c0f3.svg";